module.exports = __webpack_public_path__ + "4e14062c2f6b09298d1bf5076d2d3cb9.svg";